import { createProvider } from 'apprise-frontend-core/state/factory';
import { JSONCodec, NatsConnection } from 'nats.ws';


// connection
// ---------------------------------------------------------------------------------------------

export const [BusConnectionProvider, useBusConnection] = createProvider({

    connection: undefined! as NatsConnection,
    codec: JSONCodec()
})


// upgrade notifications
// ---------------------------------------------------------------------------------------------

export const [ UpgradeProvider, useUpgrade ] = createProvider({

    stale: false
})